import { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { User, Mail, Lock, Eye, EyeOff } from "lucide-react";

export default function RegisterGuru() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (name === "password" && value === "") setShowPassword(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post("https://backend.smpn1kamal.sch.id/api/register-guru", form);
      toast.success("Registrasi berhasil, silakan masuk");
      setTimeout(() => navigate("/"), 1500);
    } catch (err) {
      toast.error(err.response?.data?.message || "Registrasi gagal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <header className="bg-white border-b px-6 py-4 flex justify-between items-center">
        <h1 className="text-xl font-bold text-blue-700">SIPENSA</h1>
        <Link to="/" className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm hover:bg-blue-700">
          Masuk
        </Link>
      </header>

      <div className="flex flex-1 items-center justify-center">
        <div className="grid md:grid-cols-2 w-full max-w-6xl gap-10 items-center px-6">

          <div className="hidden md:flex flex-col justify-center">
            <img src="/logo.png" alt="logo" className="w-32 mb-6" />
            <h1 className="text-4xl font-bold text-black">Selamat Datang</h1>
            <h2 className="text-4xl font-bold text-blue-600">Di SIPENSA</h2>
            <p className="text-base text-gray-600 mt-4">
              Silahkan daftar menggunakan akun email yang aktif.
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md mx-auto">
            <h2 className="text-2xl font-bold text-center mb-6">Registrasi Guru</h2>

            <form onSubmit={handleSubmit} className="space-y-4">

              {/* Username */}
              <div>
                <label className="text-sm font-medium">Username</label>
                <div className="relative mt-1">
                  <User size={18} className="absolute left-3 top-3 text-gray-400" />
                  <input
                    type="text"
                    name="username"
                    value={form.username}
                    onChange={handleChange}
                    required
                    placeholder="Masukkan username"
                    className="w-full pl-10 pr-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-400 outline-none"
                  />
                </div>
              </div>

              {/* Email */}
              <div>
                <label className="text-sm font-medium">Email</label>
                <div className="relative mt-1">
                  <Mail size={18} className="absolute left-3 top-3 text-gray-400" />
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                    placeholder="Masukkan email"
                    className="w-full pl-10 pr-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-400 outline-none"
                  />
                </div>
              </div>

              {/* Password */}
              <div>
                <label className="text-sm font-medium">Kata Sandi</label>
                <div className="relative mt-1">
                  <Lock size={18} className="absolute left-3 top-3 text-gray-400" />
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={form.password}
                    onChange={handleChange}
                    required
                    placeholder="Masukkan kata sandi"
                    autoComplete="new-password"
                    className="w-full pl-10 pr-10 py-2 border rounded-md focus:ring-2 focus:ring-blue-400 outline-none"
                  />
                  {form.password.length > 0 && (
                    <button
                      type="button"
                      onClick={() => setShowPassword((prev) => !prev)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                      tabIndex={-1}
                      aria-label={showPassword ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}
                    >
                      {/* Mata TERBUKA saat terlihat, TERTUTUP saat tersembunyi */}
                      {showPassword ? <Eye size={18} /> : <EyeOff size={18} />}
                    </button>
                  )}
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition"
              >
                {loading ? "Menyimpan..." : "Daftar"}
              </button>
            </form>

            <p className="text-center text-sm text-gray-500 mt-4">
              Sudah punya akun?{" "}
              <Link to="/" className="text-blue-600 hover:underline">Masuk</Link>
            </p>
          </div>
        </div>
      </div>

      <footer className="text-center text-sm text-gray-500 pb-4">
        Sistem Informasi Presensi SMPN 1 Kamal
      </footer>
    </div>
  );
}